<script>
export default {
    name: 'BaseTimePickerSeconds',
};
</script>

<script setup>
import { computed } from 'vue';
import { TYPE } from '@/components/base-components/components/time-picker/index.js';
import BaseTimePickerPicker from '@/components/base-components/components/time-picker/components/picker.vue';
import { getSeconds } from '@/components/base-components/components/time-picker/utils/helpers.js';

const props = defineProps({
    value: {
        type: Date,
    },
    type:  {
        type:      String,
        default:   TYPE.DEFAULT,
        validator: value => Object.values(TYPE).includes(value),
    },
});

const emit = defineEmits({
    input: null,
});

const model = computed({
    get: () => (props.value ?? new Date()).getSeconds(),
    set: (value) => {
        const date = new Date(props.value ?? new Date());

        date.setSeconds(value);

        emit('input', date);
    },
});
</script>

<template>
    <base-time-picker-picker
        v-model="model"
        :items="getSeconds()"
        :type="type"
    />
</template>
